import { cn } from '@talentmesh/ui/lib/utils';
import React, { ReactNode } from 'react';

interface DialogCardContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: React.ReactNode;
    dialogTitle: ReactNode;
    dialogBody: ReactNode;
}

function DialogCardContainer({ dialogTitle, dialogBody, icon, className, ...props }: DialogCardContainerProps) {
    return (
        <div
            className={cn('bg-muted flex h-72 flex-row items-center gap-3 rounded-lg pt-3 pr-3 pl-3', className)}
            {...props}
        >
            <div className="flex flex-col justify-end">{icon}</div>
            <div className="flex flex-col justify-center gap-3">
                {dialogTitle}
                {dialogBody}
            </div>
        </div>
    );
}

export default DialogCardContainer;
